import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const QUICK_LINKS = [
  { name: "Ana Sayfa", path: "/" },
  { name: "Kurumsal", path: "/kurumsal" },
  { name: "Faaliyet Alanları", path: "/faaliyet-alanlari" },
  { name: "Proje Yaklaşımımız", path: "/proje-yaklasimimiz" },
  { name: "Gayrimenkul Geliştirme", path: "/gayrimenkul-gelistirme" },
  { name: "İletişim", path: "/iletisim" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-navy text-white/85 font-body"
    >
      <div className="h-[1px] hairline-x" />

      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-8">
        {/* Company */}
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 border border-gold/60 flex items-center justify-center font-heading font-semibold text-white text-[13px]">
              1001
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-heading font-medium text-[16px] text-white tracking-tight">
                1001 Mimarlık İnşaat
              </span>
              <span className="mt-1 text-[10px] tracking-[0.25em] uppercase text-white/50">
                ve Ticaret A.Ş.
              </span>
            </div>
          </div>

          <p className="mt-6 text-[13.5px] leading-relaxed text-white/70 max-w-sm font-light">
            Mimarlık, inşaat taahhüt, anahtar teslim proje ve gayrimenkul
            geliştirme alanlarında kurumsal disiplin ve mimari bakış açısıyla
            değer üretiyoruz.
          </p>
        </div>

        {/* Quick Links — Column A */}
        <div className="md:col-span-2">
          <div className="overline text-gold/90 mb-5">Hızlı Erişim</div>
          <ul className="space-y-3">
            {QUICK_LINKS.slice(0, 3).map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  data-testid={`footer-link-${link.path.replace("/", "") || "ana-sayfa"}`}
                  className="text-[13.5px] text-white/70 hover:text-gold transition-colors inline-flex items-center gap-2 group"
                >
                  <span className="w-3 h-[1px] bg-white/30 group-hover:bg-gold transition-colors" />
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick Links — Column B */}
        <div className="md:col-span-2">
          <div className="overline text-gold/90 mb-5 opacity-0 select-none">.</div>
          <ul className="space-y-3">
            {QUICK_LINKS.slice(3).map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  data-testid={`footer-link-${link.path.replace("/", "") || "ana-sayfa"}`}
                  className="text-[13.5px] text-white/70 hover:text-gold transition-colors inline-flex items-center gap-2 group"
                >
                  <span className="w-3 h-[1px] bg-white/30 group-hover:bg-gold transition-colors" />
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="md:col-span-4">
          <div className="overline text-gold/90 mb-5">İletişim</div>
          <ul className="space-y-4 text-[13.5px] text-white/70">
            <li className="flex items-start gap-3">
              <MapPin size={15} className="text-gold mt-0.5 shrink-0" />
              <span data-testid="footer-address">
                Eyüp Sultan, İmam Rabbani Cd.
                <br />
                No:34/B, 34885 Sancaktepe / İstanbul
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={15} className="text-gold mt-0.5 shrink-0" />
              <a
                href="tel:+902164991001"
                data-testid="footer-phone"
                className="hover:text-gold transition-colors"
              >
                (0216) 499 10 01
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={15} className="text-gold mt-0.5 shrink-0" />
              <a
                href="mailto:info@1001insaat.com.tr"
                data-testid="footer-email"
                className="hover:text-gold transition-colors break-all"
              >
                info@1001insaat.com.tr
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] text-white/50">
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-5">
            <div data-testid="footer-copyright">
              © {year} 1001 Mimarlık İnşaat ve Ticaret A.Ş. Tüm hakları saklıdır.
            </div>
            <a
              href="https://www.binbir.com.tr"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-parent-group"
              className="inline-flex items-center gap-2 text-white/50 hover:text-gold transition-colors"
            >
              <span className="w-2 h-[1px] bg-gold/70" />
              1001 Grup iştirakidir
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link
              to="/kvkk-aydinlatma-metni"
              data-testid="footer-link-kvkk"
              className="hover:text-gold transition-colors"
            >
              KVKK Aydınlatma Metni
            </Link>
            <Link
              to="/cerez-politikasi"
              data-testid="footer-link-cerez"
              className="hover:text-gold transition-colors"
            >
              Çerez Politikası
            </Link>
            <Link
              to="/gizlilik-politikasi"
              data-testid="footer-link-gizlilik"
              className="hover:text-gold transition-colors"
            >
              Gizlilik Politikası
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
